// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"5763de56e012eabc16ba","883":"4ae3c0827fd4dd7d061f"}[chunkId] + ".js";
};